<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useAppStore } from '@/store/store';
import { useUserStore } from '@/store/user';
import { usePwaStore } from '@/store/pwa';
import { useRouter } from 'vue-router';

const router = useRouter();

const appStore = useAppStore();
const { feature } = appStore;
const { hasSocialReviewLinks } = storeToRefs(appStore);

const userStore = useUserStore();
const { logoutUser } = userStore;

const pwaStore = usePwaStore();
const { showInstallPrompt } = pwaStore;
const { hasDeferredPrompt } = storeToRefs(pwaStore);
</script>

<template>
  <v-menu>
    <template #activator="{props}">
      <v-btn
        v-bind="props"
        size="x-small"
        variant="tonal"
        icon="mdi-account-circle-outline"
      />
    </template>
    <v-list>
      <v-list-item v-ripple @click="router.push({ name: 'account' })">
        <v-list-item-title>{{ $t('bottomNav.account') }}</v-list-item-title>
      </v-list-item>
      <v-list-item v-ripple @click="router.push({ name: 'documentsIndex' })">
        <v-list-item-title>{{ $t('bottomNav.documents') }}</v-list-item-title>
      </v-list-item>
      <v-list-item v-if="feature('reviews') && hasSocialReviewLinks" v-ripple @click="router.push({ name: 'reviews' })">
        <v-list-item-title>{{ $t('bottomNav.reviews') }}</v-list-item-title>
      </v-list-item>
      <v-divider />
      <v-list-item v-if="hasDeferredPrompt" v-ripple @click="showInstallPrompt">
        <v-list-item-title>{{ $t('installApp') }}</v-list-item-title>
      </v-list-item>
      <v-list-item v-ripple @click="logoutUser">
        <v-list-item-title>{{ $t('logout') }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
